import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from "react-modal-video";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/FooterTwo";
import {GoLinkExternal} from "react-icons/all";

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/" },
  { Social: <FaTwitter />, link: "https://twitter.com/" },
];

import portfolio1 from "../assets/images/eriks/Moup1_1230.jpg";
import portfolio2 from "../assets/images/eriks/Moup2_1230.jpg";
import portfolio3 from "../assets/images/eriks/Moup3_1230.jpg";
import relatedImg1 from "../assets/images/portfolio/related-image-01.jpg";
import relatedImg2 from "../assets/images/portfolio/related-image-02.jpg";

class PortfolioDetails5 extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  render() {
    return (
        <React.Fragment>
          <PageHelmet pageTitle="Portfolio Details" />

          {/*<Header*/}
          {/*  headertransparent="header--transparent"*/}
          {/*  colorblack="color--black"*/}
          {/*  logoname="logo.png"*/}
          {/*/>*/}

          {/* Start Breadcrump Area */}
          <div
              className="rn-page-title-area pt--120 pb--190 bg_image bg_image--7"
              data-black-overlay="7"
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="rn-page-title text-center pt--100">
                    {/*<h2 className="title theme-gradient">*/}
                    {/*  PortFolio1*/}
                    {/*  */}
                    {/*</h2>*/}
                    {/*<p>*/}
                    {/*  Contrary to popular belief, Lorem Ipsum is not simply random*/}
                    {/*  text.{" "}*/}
                    {/*</p>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Breadcrump Area */}

          {/* Start Portfolio Details */}
          <div className="rn-portfolio-details ptb--120 bg_color--1">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="portfolio-details">
                    <div className="inner">
                      <h3><a target="_blank" rel="noopener noreferrer"
                             href="http://www.sketchbot.tv/museum-of-untold-possibilities">
                        Museum Of Untold Possibilities <GoLinkExternal />
                      </a></h3>
                      <h4><a target="_blank" rel="noopener noreferrer"
                             href="http://www.sketchbot.tv/">
                        Sketchbot Studios <GoLinkExternal />
                      </a></h4>
                      <br/>
                      <p>
                        Served as Development Lead and for the Epic Mega Grants funded VR project: 
                        Museum of Untold Possibilities.
                      </p>
                      <p>
                        Led the creation of a VR character from inception, designed for exploration and interaction 
                        within the museum environment.
                      </p>
                      <p>
                        My responsibilities were to create an entire VR-Character from the ground up that was designed 
                        to explore the Museum and interact with the art, other museum-goers, and staff who worked there.
                      </p>

                      <div className="portfolio-view-list d-flex flex-wrap">
                        <div className="port-view">
                          <span>Role</span>
                          <h5>Lead Programmer</h5>
                        </div>

                        <div className="port-view">
                          <span>Engine</span>
                          <h5>Unreal Engine 4</h5>
                        </div>

                        <div className="port-view">
                          <span>Project Type</span>
                          <h5>Virtual Reality</h5>
                        </div>

                        <div className="port-view">
                          <span>Device</span>
                          <h5>Oculus Rift</h5>
                        </div>
                      </div>
                      {/*<div className="portfolio-share-link mt--20 pb--70 pb_sm--40">*/}
                      {/*  <ul className="social-share rn-lg-size d-flex justify-content-start liststyle mt--15">*/}
                      {/*    {SocialShare.map((val, i) => (*/}
                      {/*        <li key={i}>*/}
                      {/*          <a href={`${val.link}`}>{val.Social}</a>*/}
                      {/*        </li>*/}
                      {/*    ))}*/}
                      {/*  </ul>*/}
                      {/*</div>*/}
                    </div>
                    <div className="portfolio-thumb-inner">
                      {/*<div className="thumb position-relative mb--30">*/}
                      {/*  <img src={portfolio1} alt="Portfolio Images"/>*/}
                      {/*  <ModalVideo*/}
                      {/*      channel="youtube"*/}
                      {/*      isOpen={this.state.isOpen}*/}
                      {/*      videoId="ZOoVOfieAF8"*/}
                      {/*      onClose={() => this.setState({ isOpen: false })}*/}
                      {/*  />*/}
                      {/*  <button*/}
                      {/*      className="video-popup position-top-center"*/}
                      {/*      onClick={this.openModal}*/}
                      {/*  >*/}
                      {/*    <span className="play-icon"></span>*/}
                      {/*  </button>*/}
                      {/*</div>*/}
                      <div className="thumb mb--30">
                        <img src={portfolio1} alt="Portfolio Images"/>
                      </div>
                      <div className="thumb mb--30">
                        <img src={portfolio2} alt="Portfolio Images"/>
                      </div>

                      <div className="thumb">
                        <img src={portfolio3} alt="Portfolio Images"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Portfolio Details */}

          {/* Start Back To Top */}
          <div className="backto-top">
            <ScrollToTop showUnder={160}>
              <FiChevronUp />
            </ScrollToTop>
          </div>
          {/* End Back To Top */}

          <Footer />
        </React.Fragment>
    );
  }
}
export default PortfolioDetails5;
